module.exports = __webpack_public_path__ + "img/hmv.62ea55cc.png";